import * as _ from "lodash";
import * as $ from "jquery";

import { UiUtils } from "../../common/uiUtils";
import { viewerOptions, viewerState } from "../../viewer";

export namespace ShareUtils {

    export function measurementsFromExtension(viewer) {
        const selection = viewer.getAggregateSelection();

        const measExt = viewer.getExtension("Autodesk.Measure");
        measExt.activate();
        const measurements = measExt.getMeasurementList();
        measExt.deactivate();

        // The measurement extension switches off all selections, so let's restore them.
        if (!_.isEmpty(selection)) {
            for (let s of selection) {
                viewer.select(s.selection, s.model);
            }
        }

        const distances = measurements.filter(m => m.type === "Distance");

        return distances.map(d => {
            const picks = d.picks.map(p => {
                let pick = _.pick(p, "intersection", "modelId", "viewportIndex2d");
                pick.intersection = new THREE.Vector3(pick.intersection.x, pick.intersection.y, pick.intersection.z).toModelUnits();
                return pick;
            });
            const [value, unit] = d.distance.split(" ");

            return {
                type: d.type,
                precision: d.precision,
                value: Number(value),
                unit: unit,
                picks: picks
            };
        });
    }

    export function measurementsToExtension(viewer, measurements) {
        if (!_.isEmpty(measurements)) {
            const measExt = viewer.getExtension("Autodesk.Measure");
            if (measExt == null) {
                return;
            }

            const forgeMeasurements = measurements.map(m => {
                const fm = {
                    ...m,
                    distance: `${m.value} ${m.unit}`
                }

                for (let pick of fm.picks) {
                    pick.intersection = new THREE.Vector3(pick.intersection.x, pick.intersection.y, pick.intersection.z).toViewerUnits();
                }

                return fm;
            });

            
            measExt.activate();
            measExt.setMeasurements(forgeMeasurements);
            measExt.deactivate();
            const measButton = $("#toolbar-measurementSubmenuTool");
            measButton.addClass("pulsing-highlight");
            measButton.on("click", () => measButton.removeClass("pulsing-highlight"));

            UiUtils.notifySuccess({
                message: "This share has measurements. Open Measure tool to view them.",
                duration: 10000
            });
        }
    }

    export function filtersToExtension(filters) {
        if (!_.isEmpty(filters)) {
            viewerState.filters = {};
            for (let c of filters) {
                viewerState.filters[c.id] = c;
            }

            const filterButton = $('[id*="QuickFilterButton"]');
            filterButton.addClass("pulsing-highlight");
            filterButton.on("click", () => filterButton.removeClass("pulsing-highlight"));

            UiUtils.notifySuccess({
                message: "This share has quick filters. Open Quick Filters tool to view them.",
                duration: 10000
            });
        }
    }

    export function markupToExtension(markups) {
        if (!_.isEmpty(markups)) {
            viewerState.markups = {};
            for (let m of markups) {
                viewerState.markups[m.id] = m;
            }

            const markupButton = $('[id*="MarkupButton"]');
            markupButton.addClass("pulsing-highlight");
            markupButton.on("click", () => markupButton.removeClass("pulsing-highlight"));

            UiUtils.notifySuccess({
                message: "This share has markup. Open Markup tool to view them.",
                duration: 10000
            });
        }
    }

    export function sectionToExtension(viewer: Autodesk.Viewing.GuiViewer3D, section) {
        if (section != null) {
            const sectExt = viewer.getExtension("Autodesk.Section") as any;
            if (sectExt == null) {
                return;
            }

            if (section.cutplanes.lenght = 0) return;

            for (let i = 0; i < section.cutplanes.length; i++) {
                section.cutplanes[i][3] = section.cutplanes[i][3] * viewerOptions.unitData.modelToViewerScale;
            }

            if (section.style.toUpperCase() === "BOX") {
                if (section.cutplanes.length < 6) {
                    console.log("Not enough planes to render the box");
                    return;
                }

                let planes = []; 
                for (const cutplane of section.cutplanes) {
                    let vector4 = new THREE.Vector4(
                        cutplane[0], cutplane[1],
                        cutplane[2], cutplane[3]);

                    planes.push(vector4);
                }
                
                viewer.setCutPlanes(planes);
                $("#toolbar-sectionToolarrow").trigger("click");
                $("#toolbar-sectionTool-box").trigger("click");
            }
            else {
                sectExt.setSectionStyle(section.style.toUpperCase(), true);

                const normal = new THREE.Vector3(section.cutplanes[0][0], section.cutplanes[0][1], section.cutplanes[0][2]);

                let models = viewer.getVisibleModels();
                let bbox = new THREE.Box3();
                for (let model of models) {
                    bbox = bbox.union(model.getBoundingBox());
                }

                let center = bbox.getCenter();
                let plane = new THREE.Plane().setComponents(section.cutplanes[0][0], section.cutplanes[0][1], section.cutplanes[0][2], section.cutplanes[0][3]);
                let position = plane.projectPoint(center);

                sectExt.setSectionPlane(normal, position);
            }

            UiUtils.notifySuccess({
                message: `This share has a section ${section.style.toUpperCase() === "BOX" ? "box" : "plane"}.`,
                duration: 10000
            });
        }
    }
}